import React from 'react'
import styled from 'styled-components'
import { ReactComponent as BGElementSVG } from 'svg/whitepaperIllustration.svg'

import {
  Body2,
  HeadlineL,
  HeadlineM,
  Overline,
  Subtitle2,
  SubtitleS,
} from 'components/Text'
import Colors from 'styles/Colors'
import media from 'styles/media'

const Testimonials: React.FC<{}> = ({}) => {
  return (
    <Wrapper className="testimonials__wrapper">
      <TextWrapper>
        <Label bullet>Testimonial</Label>
        <Title>Hear what others have to say</Title>
      </TextWrapper>
      <Lines className="testimonials__lines">////////</Lines>
      <Testimonial className="testimonials__testimonial-1">
        <Message>
          “One of the benefits of the Realtime Robotics platform with Mitsubishi
          hardware is its ability to drop in nearly any application that's going
          on. So whether that's a new line designed out of the gates or an
          existing line that has personnel on it, or maybe it had some legacy
          automation that you wanted to improve, it literally can function in
          any of those systems you drop in.”
        </Message>
        <Name bullet>Tim Kalhorn</Name>
        <JobTitle>Channel Account Manager</JobTitle>
        <Company>Mitsubishi electric automation, inc.</Company>
      </Testimonial>
      <BGElement />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  min-height: 1080px;
  position: relative;
  overflow: hidden;

  ${media.fullWidth} {
    height: 54.5vw;
  }
  ${media.mobile} {
    min-height: 700px;
  }
`
const TextWrapper = styled.div`
  width: 64.3vw;
  padding: 10.1vw 0 0 12.9vw;
  ${media.tabletLandscape} {
  }
  ${media.tablet} {
    padding: 0 0 0 7vw;
  }
  ${media.mobile} {
    width: fit-content;
    padding: 0;
    margin-left: 12px;
  }
`
const Lines = styled(HeadlineM)`
  color: ${Colors.blueYonder};
  position: absolute;
  top: 10.5vw;
  right: 96px;
  transform: rotate(-90deg);
  ${media.tabletLandscape} {
    left: 87.2vw;
    right: auto;
    top: 12.1vw;
    font-size: 36px;
  }
  ${media.mobile} {
    font-size: 24px;
    line-height: 28px;
    right: -11px;
    left: auto;
    width: fit-content;
  }
`

const Testimonial = styled.div`
  width: 480px;
  min-height: 830px;
  position: absolute;
  top: 264px;
  right: 348px;
  margin-top: 50px;
  ${media.fullWidth} {
    width: 28.6vw;
    top: 15.7vw;
    right: auto;
    left: 48.9vw;
  }
  ${media.tabletLandscape} {
    right: auto;
    left: 37.2vw;
  }
  ${media.tablet} {
    left: 21vw;
    top: 250px;
  }
  ${media.mobile} {
    width: calc(100% - 24px);
    max-width: 351px;
    top: 120px;
  }
  @media screen and (max-width: 515px) {
    left: 12px;
  }
`

const Message = styled(Body2)`
  ${media.mobile} {
    font-size: 16px;
  }
`
const Name = styled(Overline)`
  margin-top: 22px;
  margin-bottom: 1vw;
  font-size: 24px;
  text-transform: none;
  padding-left: 28px;
  ::after {
    color: ${Colors.blueYonder};
    font-size: 24px;
  }
  ${media.fullWidth} {
    font-size: 1.4vw;
    margin-top: 1.3vw;
  }
`
const JobTitle = styled(Subtitle2)`
  opacity: 0.4;
  margin-top: 0.4vw;
`
const Label = styled(Overline)`
  position: relative;
  width: 250px;
  height: 16px;
  margin-top: 50px;
  top: 0px;
  text-transform: uppercase;
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.blueYonder};
  }
`
const Title = styled(HeadlineM)`
  color: ${Colors.softBlack};
  font-size: 3.2vw;
  margin-bottom: 1vw;
  width: 480px;
  ${media.tabletLandscape} {
    font-size: 54px;
    width: 80%;
  }
  ${media.mobile} {
    font-size: 36px;
  }
`
const BGElement = styled(BGElementSVG)`
  position: absolute;
  width: 23.9vw;
  height: 26.1vw;
  left: 3vw;
  top: 44.9vw;
  z-index: 5;
  transform: rotate(-5deg);
  ${media.tabletLandscape} {
    display: none;
  }
  ${media.tablet} {
  }
`

const Company = styled(Overline)``
export default Testimonials
